<template>
  <div class="wave-divider">
    <svg
      class="wave-svg"
      :class="{ 'wave-animated': reactive }"
      viewBox="0 0 1200 120"
      preserveAspectRatio="none"
    >
      <path
        d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
        :fill="color"
      />
    </svg>
  </div>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: '#ffffff'
  },
  reactive: {
    type: Boolean,
    default: false
  }
});
</script>

<style scoped>
.wave-divider {
  position: relative;
  width: 100%;
  height: 60px;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.wave-svg {
  width: calc(100% + 1.3px);
  height: 100%;
  color: currentColor;
}

.wave-animated {
  animation: wave 8s ease-in-out infinite;
}

@keyframes wave {
  0%, 100% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(-20px);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .wave-divider {
    height: 40px;
  }
}

@media (max-width: 480px) {
  .wave-divider {
    height: 30px;
  }
}
</style>